import DatePicker from "react-datepicker";
import classNames from "classnames";
import { ControlWrapper, ControlWrapProps } from "../common";
import { DatePickerWrapper } from "./style";
import { generateRandomID } from "../../../helpers/utilities";
import { textChooser } from "../../../util/textChooser";
import "react-datepicker/dist/react-datepicker.css";

export interface DatePickerProps extends Omit<ControlWrapProps,'children'|'id'> {
    onChange: (e: any) => any;
    className?: string;
    disabled?: boolean;
    name?: string;
    minAgeRequired?: boolean;
    minDate?: Date;
    maxDate?: Date;
    selected?: Date | null;
    hasError?: boolean;
}

export const DatePickerCalendar = (props: DatePickerProps) => {
    
    const randomId = generateRandomID();
    const dateObj = new Date();
    
    const maxNumOfYears = dateObj.getFullYear() - (props.minAgeRequired ? 18 : 0);
    const maxDate = props.minAgeRequired ? new Date(dateObj.setFullYear(maxNumOfYears)) : null;

    const optionYears = Array.from({length: maxNumOfYears} , (e , i) => maxNumOfYears - i);
    const optionMonths = textChooser("txt212").split(",");

    return (
        <ControlWrapper 
            label={props.label} 
            subLabel={props.subLabel}
            testId={props.testId} 
            id={randomId}
        >
            <DatePickerWrapper>
                <DatePicker
                    name={props.name}
                    selected={props.selected}
                    className={classNames(props.className, {"hasError": props.hasError})}
                    onChange={props.onChange}
                    renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth,
                        decreaseMonth,
                        increaseMonth,
                        }) => (
                        <div style={{margin: 5, display: "flex", justifyContent: "center"}}>
                            <button onClick={decreaseMonth}>
                                {"<"}
                            </button>
                            <select
                                value={(new Date(date)).getFullYear()}
                                onChange={({ target:{value}}) => changeYear(+value)}
                            >
                                {optionYears.map((year) =>
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                )}
                            </select>
                            <select
                                value={optionMonths[(new Date(date)).getMonth()]}
                                onChange={({target: {value}}) => changeMonth(optionMonths.indexOf(value))}
                            >
                                {optionMonths.map((month) =>
                                    <option key={month} value={month}>
                                        {month}
                                    </option>
                                )}
                            </select>
                            <button onClick={increaseMonth}>
                                {">"}
                            </button>
                        </div>
                    )}
                    minDate={props.minDate ?? null}
                    maxDate={props.maxDate ?? maxDate}
                    disabled={props.disabled}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="dd/MM/yyyy"
                />
            </DatePickerWrapper>
        </ControlWrapper>
    )
}